import { Link } from "react-router";
import { cn } from "@repo/ui/lib/utils";
import { Post } from '~/types/types';
import { formatTimeUtc7, hostName } from '~/utils/format';
import { Img } from 'openimg/react';

type Variant = "featured" | "mini" | "list";

export type News = {
  id: string | number;
  title: string;
  excerpt?: string;
  image: string;
  date?: string;
  author?: string;
};

export default function NewsCard({
  data,
  variant = "list",
  className,
}: {
  data: Post;
  variant?: Variant;
  className?: string;
}) {
  if (variant === "featured" || variant === "mini") {
    return (
      <Link
        to={`/tin-tuc/${data.slug}`}
        className={cn("relative block w-full h-full", className)}
      >
        <div className="relative w-full h-[220px] overflow-hidden rounded-2xl">
          <Img
            width={324}
            height={220}
            fit="contain"
            src={hostName(data.thumbnail[0]?.path || "/")}
            alt={data.title}
            className="absolute object-cover w-full h-full"
          />
          <div
            className={cn(
              "absolute bottom-0 left-0 h-1/2 w-full from-transparent",
              variant === "featured"
                ? "bg-gradient-to-b to-primary/80"
                : "bg-gradient-to-b  to-primary"
            )}
          />
        </div>
        <div className="absolute bottom-0 left-0 right-0 px-4 py-3 text-white">
          {data.publishedAt ? (
            <span className="text-sm opacity-90">{data.publishedAt}</span>
          ) : null}
          <h3
            className={cn(
              "font-helve line-clamp-2",
              variant === "featured"
                ? "text-2xl md:text-3xl"
                : "text-base md:text-lg font-bold leading-6"
            )}
          >
            {data.title}
          </h3>
        </div>
      </Link>
    );
  }

  // list variant
  return (
    <Link
      to={`/tin-tuc/${data.slug}`}
      className={cn("block w-full h-full", className)}
    >
      <div className="rounded-2xl overflow-hidden w-full h-[220px] md:h-[240px]">
        <Img
          width={384}
          height={260}
          src={hostName(data.thumbnail[0]?.path || "/")}
          alt={data.title}
          className="object-cover w-full h-full"
        />
      </div>
      <div className="mt-3">
        <div className="text-sm">
          <span className="text-primary">By Kland</span>
          {data.publishedAt ? <span className="text-gray-600"> | </span> : null}
          {formatTimeUtc7(data.publishedAt)}
        </div>
        <h3 className="mt-2 text-xl font-helve text-primary line-clamp-2">
          {data.title}
        </h3>
        {data.description ? (
          <p className="mt-2 font-normal line-clamp-2">{data.description}</p>
        ) : null}
      </div>
    </Link>
  );
}

